<template>
  <div>
    <div class="overlay" @click="$emit('close')"></div>
    <div class="modal_fixed">
      <div class="popup_box zero_balance modal_cont" id="">
        <img :src="closeIconSrc" class="btn_close" @click="$emit('close')">
        <h1>{{ getTranslations.home_modals_zero_balance_zero_game_balance }}</h1>
        <img :src="zeroBalanceSrc" class="zero_bal_img" alt="">
        <p>{{ getTranslations.home_modals_zero_balance_unlock_more_games_msg }}</p>
        <button type="" v-if="!hideStore" @click.prevent="toBundlesPage">
          {{ getTranslations.home_modals_zero_balance_unlock_games }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapState } from 'vuex';
import SkinMixin from '@/common/mixins/skin';

export default {
  name: 'zero-balance',
  mixins: [SkinMixin],
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    toBundlesPage() {
      this.storeModalForHomePage(null);
      this.$router.push('/home/store');
    },
  },
  computed: {
    closeIconSrc() {
      return this.$_skinImage({ fileName: 'store/icon-close-back-popup.svg', skins: [100] });
    },
    zeroBalanceSrc() {
      return this.getTranslations.home_modals_zero_balance_image || this.$_skinImage({ fileName: 'popups/zero_ballance.png', skins: [100] });
    },
    ...mapState('common', [
      'hideStore',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ZeroBalance.vue